export enum CustomFormat {
  Image = "image",
  Video = "video",
  Iframe = "iframe"
}
